import {
  createActions,
  REQUEST,
  SUCCESS,
  FAILURE,
  createRequestTypes
} from "./index";

export const ADMIN_LOGIN = createRequestTypes("ADMIN_LOGIN");
export const adminLogin = {
  request: (data, history) =>
    createActions(ADMIN_LOGIN[REQUEST], { data, history }),
  success: data => createActions(ADMIN_LOGIN[SUCCESS], data),
  failure: error => createActions(ADMIN_LOGIN[FAILURE], error)
};

export const LOGOUT = "LOGOUT";
export const logout = () => {
  return {
    type: LOGOUT
  };
};
